import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';

import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { resolveEntityCellData } from  'resolvers/resolveEntityCellData';
import { isVisible } from 'resolvers/getVisibleEntities';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc EpostInsuranceInformation defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { EpostInsuranceInformationService } from 'services/epostInsuranceInformation';
 *
 * // create service instance and send/cancel request
 * const epostInsuranceInformationService = new EpostInsuranceInformationService();
 * const result = await epostInsuranceInformationService.fetchData( '<user-id>' ); // fetch data
 * epostInsuranceInformationService.cancel(); // cancel an active request
 */
export class EpostInsuranceInformationService extends HttpService {

      // fetch call control widget data
      async fetchComponentData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );


        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge(
                    {
                        context: { callId }
                    },
                    data
                )
            } );

            const component = get( response, 'body.component', {} );
            const sections = get( component, 'structure.sections', {} );
            const widgetConfig = get( component, 'structure.widgetConfig', {} );
            const insuranceFields = get( component, 'structure.sections.insurance.fields', [] );
            const visibility = get( response, 'body.component.visibility', {} );

            // update insurance fields
            sections.insurance.fields = resolveEntityCellData( { items: insuranceFields, component } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.data.state' ),
                    visibility: get(response,'body.component.visibility'),
                    sections: sections,
                    navActions: get( component, 'structure.navActions', [] ),
                    options: get( response, 'body.component.data.options' ),
                    widgetConfig: widgetConfig,
                    changeConfirmation: get( component, 'structure.widgetConfig.changeConfirmation', {} ),
                    defaultDescription: isVisible( get( component, 'structure.widgetConfig.defaultDescription', {} ), visibility ) ? get( response, 'body.component.structure.widgetConfig.defaultDescription', {} ): {},
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

     // submit current step data
     async sumbitStepdata( { url = {}, data = {}, config = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge(
                    {
                        context: { callId }
                    },
                    data
                )
            } );

            if( SERVICE_RESPONSE_STATUS.FAILURE === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {

                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: {
                        title: get( response, 'body.component.data.description' ),
                        navActions: get( config, 'onFailure.actions' )
                    }
                };
            }

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }


    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
